module.exports = __webpack_public_path__ + "static/media/Asset 54.47c6a298.jpg";